document.addEventListener('DOMContentLoaded', () => {
  const filterLinks = document.querySelectorAll('.js-filter-link');
  const navLinks    = document.querySelectorAll('.blogFilterNav a');
  const articles    = document.querySelectorAll('.blogArticle');
  const heading     = document.querySelector('.blogHeadingTitle');
  if (!heading) return;

  const overlay = document.createElement('div');
  overlay.id = 'blog-blackout';
  document.body.appendChild(overlay);

  const reAnimate = (el) => {
    el.classList.remove('animate-up');
    void el.offsetWidth;
    el.classList.add('animate-up');
  };

  const applyFilter = (tag) => {
    articles.forEach(el => {
      const tags = el.dataset.tags.split(',');
      el.hidden = !(tag === 'All' || tags.includes(tag));
    });

    heading.textContent = tag;

    filterLinks.forEach(link =>
      link.classList.toggle('is-active', link.dataset.filter === tag)
    );

    reAnimate(heading);
  };

  heading.classList.add('animate-up');
  applyFilter('All');

  const runOverlay = (callback) => {
    overlay.classList.add('show');
    setTimeout(() => {
      callback();
      overlay.classList.remove('show');
    }, 750);
  };

  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const tag = link.dataset.filter;
      if (tag) {
        runOverlay(() => applyFilter(tag));
      } else {
        const href = link.getAttribute('href');
        runOverlay(() => { window.location.href = href; });
      }
    });
  });
});

  document.addEventListener('DOMContentLoaded', () => {
    const articles = document.querySelectorAll('.blogArticle');
  
    const revealObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is‑visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
  
    articles.forEach(el => revealObserver.observe(el));
  
    const originalApply = window.applyFilter;
  
    window.applyFilter = (tag) => {
      originalApply(tag);
  
      document.querySelectorAll('.blogArticle:not([hidden])')
        .forEach(el => {
          if (!el.classList.contains('is‑visible')) {
            revealObserver.observe(el);
          }
        });
    };
  });